// ========================================================================
// This file is auto-generated by the `yarn naptime:types` script
// ========================================================================
import NaptimeResource from 'bundles/naptimejs/resources/NaptimeResource';

// ========================================================================
// Definitions for resource data types
// ========================================================================

export type EnterpriseCustomizedMessageType = 'MEMBER_INVITATION' | 'WELCOME';

export interface RenderableHtmlMetadata {
  hasMath: boolean;
  hasCodeBlock: boolean;
  isPlainText: boolean;
  hasAssetBlock: boolean;
}

export interface RenderableHtmlWithMetadata {
  renderableHtml: string;
  metadata: RenderableHtmlMetadata;
}

export interface CmlContentType {
  dtdId: string;
  value: string;
  renderableHtmlWithMetadata?: RenderableHtmlWithMetadata | null;
}

export interface CmlContentCml {
  typeName: 'cml';
  definition: CmlContentType;
}

export type CmlContent = CmlContentCml;

export type CmlContentTypeName = 'cml';

export interface EnterpriseCustomizedMessagesV1 {
  id: string;
  scope: string;
  messageType: EnterpriseCustomizedMessageType;
  title: string;
  content: CmlContent;
}

export interface EnterpriseCustomizedMessage {
  title: string;
  content: CmlContent;
}

// ========================================================================
// Definitions for naptime-link
// ========================================================================

export interface EnterpriseCustomizedMessagesV1Connection {
  elements: Array<EnterpriseCustomizedMessagesV1> | null;
}

// ========================================================================
// Definitions for naptime-link queries
// ========================================================================

export interface EnterpriseCustomizedMessagesV1DeleteQuery {
  EnterpriseCustomizedMessagesV1: {
    delete: EnterpriseCustomizedMessagesV1Connection | null;
  } | null;
}

export interface EnterpriseCustomizedMessagesV1DeleteQueryVariables {
  id: string;
  includes?: string | null;
}

export interface EnterpriseCustomizedMessagesV1GetQuery {
  EnterpriseCustomizedMessagesV1: {
    get: EnterpriseCustomizedMessagesV1Connection | null;
  } | null;
}

export interface EnterpriseCustomizedMessagesV1GetQueryVariables {
  id: string;
  includes?: string | null;
}

export interface EnterpriseCustomizedMessagesV1GetOrDefaultQuery {
  EnterpriseCustomizedMessagesV1: {
    getOrDefault: EnterpriseCustomizedMessagesV1Connection | null;
  } | null;
}

export interface EnterpriseCustomizedMessagesV1GetOrDefaultQueryVariables {
  id: string;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-link mutations
// ========================================================================

export interface EnterpriseCustomizedMessagesV1PreviewMutation {
  EnterpriseCustomizedMessagesV1: {
    preview: EnterpriseCustomizedMessagesV1Connection | null;
  } | null;
}

export interface EnterpriseCustomizedMessagesV1PreviewMutationVariables {
  id: string;
  input: EnterpriseCustomizedMessage;
  includes?: string | null;
}

export interface EnterpriseCustomizedMessagesV1UpdateMutation {
  EnterpriseCustomizedMessagesV1: {
    update: EnterpriseCustomizedMessagesV1Connection | null;
  } | null;
}

export interface EnterpriseCustomizedMessagesV1UpdateMutationVariables {
  id: string;
  input: EnterpriseCustomizedMessage;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-js
// ========================================================================

// Recursively applies Partial<T> to supported culling by the `fields` param.
type PartialConstruction<T> = {
  [TKey in keyof T]?: T[TKey] extends Array<infer TElement>
    ? Array<PartialConstruction<TElement>>
    : T[TKey] extends object
    ? PartialConstruction<T[TKey]>
    : T[TKey];
};

export class EnterpriseCustomizedMessagesV1NaptimeResource extends NaptimeResource {
  static RESOURCE_NAME = 'enterpriseCustomizedMessages.v1' as const;

  declare id: string;

  declare scope: string;

  declare messageType: EnterpriseCustomizedMessageType;

  declare title: string;

  declare content: CmlContent;

  // Intentionally "useless" to supply params type
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(params: PartialConstruction<EnterpriseCustomizedMessagesV1>) {
    super(params);
  }
}
